<template>
  <van-nav-bar
    :left-arrow="nav.back"
    @click-left="onClickLeft"
  >
    <template #left>
      <div v-if="nav.title!='Smart Sketcher AI'" class="vanNavBarLefttitle">
          <van-icon name="arrow-left" />
          {{nav.title}}
      </div>
      <img v-else style="width: 60%;" @click="$router.push({ path: `/` })" src="@/assets/img/logo_yoko.svg" alt="" />
    </template>
    <template #right v-if="nav.chat">
      <div class="iconBox" @click="goChat">
        <img class="icon" src="../../assets/img/icon/icon_add.png" />
      </div>
    </template>
  </van-nav-bar>
</template>

<script>
import Vue from "vue";
import { NavBar } from "vant";

Vue.use(NavBar);
export default {
  props: {
    nav: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    onClickLeft() {
      if((this.$route.query.id!=''&& this.nav.chat) || (this.$route.query.ai=='' && this.nav.chat)){
        this.$router.push({ path: `/` });
        return
      }
      this.$router.back(1);
    },
    goChat() {
      if(this.$route.path=='/chat'){
        window.location.reload();
        return
      }
      this.$router.push({ path: `/chat` });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue